export class EmailLogWebHookDto {
  id: number;
  event: string;
  email: string;
  date: string;
  'message-id': string;
  sending_ip: string;
  tag: string;
  template_id: number;
  tags: string[];
  ts: number;
  ts_event: number;
  ts_epoch: number;
  subject: string;
  reason: string;
}
